import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  IconButton,
  Tooltip,
} from "@aurem/ui";
import { FilterIcon } from "lucide-react";
import { useState } from "react";
import { useTranslations } from "../i18n";
import { QueryToolbarProps } from "./types";

export const FiltersPanel = ({
  filtersCount,
  filters,
  onApplyFilters,
  onResetFilters,
}: QueryToolbarProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { t } = useTranslations();

  const openDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const handleApplyFilters = () => {
    onApplyFilters?.();
    closeDrawer();
  };

  return (
    <div className="relative">
      <Tooltip
        content={t("components.queryToolbar.filters")}
        placement="bottom-start"
      >
        <IconButton
          variant="ghost"
          color="neutral"
          content={<FilterIcon size={20} />}
          aria-label={t("components.queryToolbar.ariaFilters")}
          onClick={openDrawer}
        />
      </Tooltip>
      {filtersCount && filtersCount > 0 && (
        <div className="absolute -top-0.5 end-0 bg-primary-500 text-white text-xs font-normal rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
          {filtersCount > 9 ? "9+" : filtersCount}
        </div>
      )}
      <Drawer
        open={drawerOpen}
        onOpenChange={setDrawerOpen}
        title={t("components.queryToolbar.filters")}
      >
        <DrawerBody>{filters}</DrawerBody>
        <DrawerFooter>
          <div className="flex items-center gap-2">
            {onResetFilters && (
              <Button variant="ghost" color="neutral" onClick={onResetFilters}>
                {t("components.queryToolbar.reset")}
              </Button>
            )}
          </div>
          <div className="flex items-center gap-2 ms-auto">
            <Button variant="outlined" color="neutral" onClick={closeDrawer}>
              {t("components.queryToolbar.cancel")}
            </Button>
            <Button onClick={handleApplyFilters}>
              {t("components.queryToolbar.apply")}
            </Button>
          </div>
        </DrawerFooter>
      </Drawer>
    </div>
  );
};
